/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:50:49
 * @Last Modified by: Dac Hai
 * @Last Modified time: 2020-12-29 23:58:39
 */
import utils from '@/app/utils/gfUtils';

/**
 * Submit Button template
 * @returns string
 */
export default (): string => {
  return `
<div id="md-submit">
	<span class="md-title">
		<span class="mer-title">
			<i class="gpicon-form-submitbutton"></i>
			<span>Submit Button</span>
		</span>
	</span>
	<div class="simple-tabs">
		<ul class="simple-tabs-item">
			<li>
				<a href="#">${utils.svgIcon('settings')} Settings </a>
			</li>
			<li>
				<a href="#">${utils.svgIcon('design')} Design </a>
			</li>
		</ul>
		<div class="md-body settings-panel"></div>
		<div class="md-body design-panel"></div>
		<textarea class="txtStyleHidden inptxt gf-hide"></textarea>
	</div>
	<div class="md-footer">
		<button class="btnSave">APPLY</button>
		<button class="btnCancel">CANCEL</button>
	</div>
</div>
  `;
};
